import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { ScrollArea } from 'ui/scrollArea';
import { ResourceType } from 'modules/missionControl/lib/types';
import { ActivityItem as ActivityItemType, ActivityItems } from '../Launchpad.types';
import { CampaignItem } from './CampaignItem';
import { JourneyItem } from './JourneyItem';
import { ListItem } from './ListItem';
import { TemplateItem } from './TemplateItem';
import { MAX_ITEM_TITLE_WIDTH } from './ActivityItem.constants';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.double};
`;

export const ActivityFeed = ({
  activityItems,
}: {
  activityItems: ActivityItems;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [maxTitleWidth, setMaxTitleWidth] = useState(MAX_ITEM_TITLE_WIDTH); // fallback value

  useEffect(() => {
    if (containerRef?.current) {
      const itemWidth = containerRef.current.offsetWidth;
      setMaxTitleWidth(itemWidth - 128); // container width - padding and thumbnail
    }
  }, []);

  return (
    <ScrollArea>
      <Content ref={containerRef}>
        {activityItems.map((item: ActivityItemType) => {
          const { resourceType, id } = item;

          switch (resourceType) {
            case ResourceType.Campaign:
              return <CampaignItem item={item} key={id} titleWidth={maxTitleWidth} />;
            case ResourceType.Journey:
              return <JourneyItem item={item} key={id} titleWidth={maxTitleWidth} />;
            case ResourceType.List:
              return <ListItem item={item} key={id} titleWidth={maxTitleWidth} />;
            case ResourceType.Template:
              return <TemplateItem item={item} key={id} titleWidth={maxTitleWidth} />;
            default:
              return null;
          }
        })}
      </Content>
    </ScrollArea>
  );
};
